import { render, staticRenderFns } from "./LiveBigBannerCell.vue?vue&type=template&id=306c159d&scoped=true"
import script from "./LiveBigBannerCell.vue?vue&type=script&setup=true&lang=js"
export * from "./LiveBigBannerCell.vue?vue&type=script&setup=true&lang=js"
import style0 from "./LiveBigBannerCell.vue?vue&type=style&index=0&id=306c159d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306c159d",
  null
  
)

export default component.exports